import { images } from "@/data/content";

// Official Pristine Water Systems logo (supplied by client). Do not alter/redraw.
export default function Logo({ variant = "dark", className = "" }) {
  if (variant === "light") {
    // On dark backgrounds, present the logo on a clean white chip.
    return (
      <span className={`inline-flex items-center rounded-lg bg-white px-3 py-2 ${className}`} data-testid="site-logo">
        <img src={images.logo} alt="Pristine Water Systems" className="h-8 w-auto" />
      </span>
    );
  }
  return (
    <img
      src={images.logo}
      alt="Pristine Water Systems"
      data-testid="site-logo"
      className={`h-10 w-auto ${className}`}
    />
  );
}
